/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import ButtonIcon from 'DesignSystem/ButtonIcon/index'
import React from 'react'
import Switch from 'DesignSystem/Svgs/Switch/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Images/ActiveTab/Images/Content/Content/Content/Comparison/Content/Content/Actions/Choose/SwitchImages/Content"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<ButtonIcon
  viewPath={`${viewPath}/ButtonIcon`}
 marginBottom="auto"
 onClick={onClick}
 marginLeft={dtSpaceS}
 marginRight={dtSpaceS}
>
{childProps => (
<Switch
{...childProps}
  viewPath={`${viewPath}/Switch`}
 width={12}
 height={12}
 stroke="rgba(0,0,0,0.7)"
/>
)}
</ButtonIcon>
{children}
</React.Fragment>)
}